export interface DailyGameCta {
  text: string;
  link: string;
  deeplink: string;
  investDeeplink: string;
}

export interface DailyGameConfig {
  keyboardSymbols: string[];
  reward: number;
  cta: DailyGameCta;
  cipherLength: number;
  mocksTip?: string;
}

export interface DailyGameState {
  config: DailyGameConfig;
  // клавиатура символов
  inputCipher: DailyGameInputItem[];
  showResultModal: boolean;
  // введенный шифр, так как могут быть одинаковые буквы, которые соберутся из inputCipher в неправильном порядке
  cipher: string;
  // были ошибки при попытке ввести шифр
  isWasFails: boolean;
}

// набор символов
export interface DailyGameInputItem {
  letter: string;
  key: number; // порядковый номер в сетке
  status: DailyGameInputLetterStatus;
}

export enum DailyGameInputLetterStatus {
  Idle = 'Idle',
  Valid = 'Valid',
  Invalid = 'Invalid',
  Fetching = 'Fetching',
}
